import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import DataTable from '../components/DataTable';
import './StaffPage.css';

const MyExamsPage = () => {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyExams();
  }, []);

  const fetchMyExams = async () => {
    try {
      setLoading(true);
      // Dette endpoint henter kun opgaver for den indloggede censor (via token)
      const res = await apiClient.get('/api/allocation/my-exams');
      setExams(res.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // Helper til at forkorte rollenavnet
  const formatRole = (roleString) => {
    if (!roleString) return '';
    if (roleString.includes('Skriftlig')) return 'Skriftlig';
    return roleString; // F.eks. 'Mundtlig'
  };

  // Definer kolonner til DataTable
  const columns = [
    {
      header: 'Termin',
      width: '15%',
      accessor: 'termin_navn'
    },
    {
      header: 'Prøve',
      width: '10%',
      accessor: 'prøve',
      render: (row) => <strong>{row.prøve}</strong>
    },
    {
      header: 'Min Rolle',
      width: '20%',
      accessor: 'opgave_type',
      render: (row) => (
        <span className="role-badge censor-badge">
          {formatRole(row.opgave_type)}
        </span>
      )
    },
    {
      header: 'Skal til (Sprogcenter)',
      width: '35%',
      accessor: 'sprogcenter_navn',
      render: (row) => (
        <div>
          <div style={{color: '#003366', fontWeight: '600'}}>{row.sprogcenter_navn}</div>
          <div style={{fontSize: '0.85rem', color: '#666'}}>
            {row.adresse}, {row.postnummer} {row.forstad}
          </div>
        </div>
      )
    },
    {
      header: 'Antal Kursister',
      width: '20%',
      accessor: 'deltagere',
      align: 'right',
      render: (row) => (
        <span style={{fontWeight: 'bold', fontSize: '1.1rem'}}>
          {row.deltagere}
        </span>
      )
    }
  ];

  return (
    <div>

      <div className="table-card">
        <DataTable 
          columns={columns}
          data={exams}
          loading={loading}
          noDataMessage="Du har ingen tildelte opgaver i øjeblikket."
          initialSortKey="termin_navn"
        />
      </div>
    </div>
  );
};

export default MyExamsPage;